export default {
  ClientParams: {
    HOST: "ws://52.71.3.123:80",
    USER: 'DataClient',
    PASSWORD: 'password',
    VPN: '@@vpnName',
    RECONNECT_INTERVAL: 3000
  },
  InsightsSearch: {
    NUM_TOP_INSIGHTS_PER_SLIDE: 8,
    TOP_INSIGHTS_SLIDE_PAUSE_DURATION: 10000,
    TOP_INSIGHTS_SLIDE_SPEED: 700
  },
  DOUBLE_CLICK_MS: 200,
  DEFAULT_LEGEND_COLORS: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#FFF200', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf', '#000000'],
  EXTENDED_LEGEND_COLORS: [
    "#F44336", "#673AB7", "#03A9F4",
    "#E91E63", "#3F51B5", "#00BCD4",
    "#9C27B0", "#2196F3", "#009688",
    "#4CAF50", "#FFEB3B", "#FF5722",
    "#8BC34A", "#FFC107", "#795548",
    "#CDDC39", "#FF9800", "#9E9E9E",

    "#607D8B", "#311B92", "#01579B",
    "#B71C1C", "#1A237E", "#006064",
    "#880E4F", "#0D47A1", "#004D40",
    "#4A148C", "#1B5E20", "#33691E",
    "#827717", "#F57F17", "#FF6F00",
    "#E65100", "#BF360C", "#3E2723",

    "#263238", "#B388FF", "#84FFFF",
    "#FF8A80", "#8C9EFF", "#A7FFEB",
    "#FF80AB", "#82B1FF", "#B9F6CA",
    "#EA80FC", "#80D8FF", "#CCFF90",
    "#F4FF81", "#FFE57F", "#FF9E80",
    "#FFFF8D", "#FFD180", "#D50000",

    "#C51162", "#304FFE", "#00B8D4",
    "#AA00FF", "#2962FF", "#00BFA5",
    "#6200EA", "#0091EA", "#00C853",
    "#64DD17", "#FFAB00", "#E57373",
    "#AEEA00", "#FF6D00", "#F06292",
    "#FFD600", "#DD2C00", "#BA68C8",

    "#9575CD", "#81C784", "#FF8A65",
    "#7986CB", "#AED581", "#A1887F",
    "#64B5F6", "#DCE775", "#E0E0E0",
    "#4FC3F7", "#FFF176", "#90A4AE",
    "#4DD0E1", "#FFD54F", "#E53935",
    "#4DB6AC", "#FFB74D", "#D81B60",

    "#8E24AA", "#039BE5", "#7CB342",
    "#5E35B1", "#00ACC1", "#C0CA33",
    "#3949AB", "#00897B", "#FDD835",
    "#1E88E5", "#43A047", "#FFB300",
    "#FB8C00", "#F4511E", "#6D4C41",
    "#757575", "#546E7A"
  ],
  EXPRESSION_REGEX: /([\=\+\-\*\/\(\)\,\[\]\>\<\!])/
};



// WEBPACK FOOTER //
// ./src/config/config.js